import { StepName } from '|/app/services';
import { PageEventContextValue } from '|/context';

const KIQ: PageEventContextValue = {
  pageName: 'Final Details',
  pageSubName: 'KIQ',
  sectionName: 'Final Details'
};
const BAV: PageEventContextValue = {
  pageName: 'Final Details',
  pageSubName: 'Bank Account Verification',
  sectionName: 'Final Details'
};
const INCOME: PageEventContextValue = {
  pageName: 'Final Details',
  pageSubName: 'Income',
  sectionName: 'Final Details'
};
const ADDRESS: PageEventContextValue = {
  pageName: 'Final Details',
  pageSubName: 'Address',
  sectionName: 'Final Details'
};
const TRADE: PageEventContextValue = {
  pageName: 'Final Details',
  pageSubName: 'Trade',
  sectionName: 'Final Details'
};
const ADDITIONAL_INCOME: PageEventContextValue = {
  pageName: 'Final Details',
  pageSubName: 'High Risk',
  sectionName: 'Final Details'
};
const SELFIE: PageEventContextValue = {
  pageName: 'Final Details',
  pageSubName: 'Selfie',
  sectionName: 'Final Details'
};

export const PAGE_EVENT_MAPPINGS: Record<string, PageEventContextValue> = {
  'down-payment': { pageName: 'Payment', pageSubName: null, sectionName: 'Checkout' },
  'autopay-enrollment': {
    pageName: 'Autopay Enrollment',
    pageSubName: null,
    sectionName: 'Checkout'
  },
  'buyer-identity': { pageName: 'Identity', pageSubName: null, sectionName: 'Checkout' },
  'co-signer-identity': {
    pageName: 'Cosigner Identity',
    pageSubName: null,
    sectionName: 'Checkout'
  },
  'transfer-select-slot': { pageName: 'Schedule', pageSubName: null, sectionName: 'Checkout' },
  'review-order': { pageName: 'Review Order', pageSubName: null, sectionName: 'Checkout' },
  'complete-purchase': { pageName: 'Place Order', pageSubName: null, sectionName: 'Checkout' },
  _verification: { pageName: 'Final Details', pageSubName: null, sectionName: 'Final Details' },

  'identity-verification': KIQ,
  [StepName.IdentityVerification]: KIQ,
  bav: BAV,
  [StepName.BAV]: BAV,
  income: INCOME,
  [StepName.Income]: INCOME,
  address: ADDRESS,
  [StepName.Address]: ADDRESS,
  'trade-verification': TRADE,
  [StepName.TradeVerification]: TRADE,
  'additional-income': ADDITIONAL_INCOME,
  [StepName.AdditionalIncome]: ADDITIONAL_INCOME,
  'selfie-verification': SELFIE,
  [StepName.SelfieVerification]: SELFIE
};

export function getPageEventContext(stepUrl: string): PageEventContextValue | null {
  return PAGE_EVENT_MAPPINGS[stepUrl] ?? null;
}
